import { isTelegramWebApp } from './telegramBridge'
import type { MessengerPlatform } from './types'

declare global {
  interface Window {
    Telegram?: {
      WebApp?: unknown
    }
    WebApp?: {
      initData?: string
      initDataUnsafe?: { start_param?: string }
    }
  }
}

export const detectPlatform = (): MessengerPlatform => {
  if (typeof window === 'undefined') {
    return 'browser'
  }

  if (isTelegramWebApp()) {
    return 'telegram'
  }

  const maxInitData = window.WebApp?.initData
  if (maxInitData && maxInitData.length > 0) {
    return 'max'
  }

  return 'browser'
}
